const initialState = {
  percent: 0,
};

export const videoStats = (state = initialState, action) => {
  switch (action.type) {
    case "SET_VIDEO_PERCENT":
      return {
        ...state,
        percent: action.payload,
      };
    default:
      return state;
  }
};

